import { Component, ElementRef, inject, OnInit, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { SlickAriaFixService } from './services/slick-aria-fix.service';

import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';
import { Topbar } from './components/topbar/topbar';
import { MenuPurchase } from './components/menu-purchase/menu-purchase';
import { MenuLogosMovil } from './components/menu-logos-movil/menu-logos-movil';
import { SearchMovil } from './components/search-movil/search-movil';
import { Cookie } from './components/cookie/cookie';
import { ScrollToUp } from './components/scroll-to-up/scroll-to-up';
import { MegamenuNew } from './components/megamenu-new/megamenu-new';
import { MegamenuUsed } from './components/megamenu-used/megamenu-used';
import { MegamenuSpare } from "./components/megamenu-spare/megamenu-spare";
import { MegamenuCustomerService } from "./components/megamenu-customer-service/megamenu-customer-service";
import { MegamenuDigitalSolutions } from "./components/megamenu-digital-solutions/megamenu-digital-solutions";

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Header,
    Footer,
    Topbar,
    MenuPurchase,
    MenuLogosMovil,
    SearchMovil,
    Cookie,
    ScrollToUp,
    MegamenuNew,
    MegamenuUsed,
    MegamenuSpare,
    MegamenuCustomerService,
    MegamenuDigitalSolutions
],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected readonly title = signal(
    'Maquinaria pesada, agrícola, industrial y equipo ligero | Tracsa Cat®'
  );
  private renderer = inject(Renderer2);
  private _elementRef = inject(ElementRef);
  private platformId = inject(PLATFORM_ID);
  private slickAriaFix = inject(SlickAriaFixService);

  ngOnInit(): void {
    this._elementRef.nativeElement.removeAttribute('ng-version');
    if (isPlatformBrowser(this.platformId)) {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if (isSafari) {
        this.renderer.addClass(document.body, 'safari');
      }
    }
    this.slickAriaFix.init();
  }
}
